import { useCallback, useEffect } from 'react';
import { useSittJoyride } from '../../../../shared/tours/useSittJoyride';
import { hasSeenTour } from '../../../../shared/tours/tourStorage';
import { CentroTabId } from '../types/centro.types';
import {
    CENTRO_GENERAL_TOUR_KEY,
    centroGeneralTourSteps,
    getCentroTabTourSteps,
} from '../tours/centroFormTours';

const AUTO_TOUR_DELAY_MS = 700;

export function useCentroFormTour(isLoading: boolean, activeTab: CentroTabId) {
    const { Tour, runTour } = useSittJoyride({ storageKey: CENTRO_GENERAL_TOUR_KEY });

    useEffect(() => {
        if (isLoading || hasSeenTour(CENTRO_GENERAL_TOUR_KEY)) return;
        const timer = window.setTimeout(() => runTour(centroGeneralTourSteps), AUTO_TOUR_DELAY_MS);
        return () => window.clearTimeout(timer);
    }, [isLoading, runTour]);

    const startGeneralTour = useCallback(() => {
        runTour(centroGeneralTourSteps);
    }, [runTour]);

    const startTabTour = useCallback(() => {
        runTour(getCentroTabTourSteps(activeTab));
    }, [activeTab, runTour]);

    return { Tour, startGeneralTour, startTabTour };
}
